import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";
import { openModal } from "../redux/features/modalSlice";
import a2only from "../assets/image/a2only.png";
import Cookies from "js-cookie";
// import user from "../assets/images/";
// import logo from "../assets/images/logo.png";
import { logoutAdmin } from "../redux/services/authService/authApi";
import { TfiMenu } from "react-icons/tfi";
import { FiCheck, FiInbox } from "react-icons/fi";
import { errorToast, successToast } from "../Utils/toast";
import { getUserRole, getAdminData } from "../Utils/role";
import { useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiSearch,
  FiBell,
  FiUser,
  FiSettings,
  FiLogOut,
} from "react-icons/fi";
import {
  getDropdownNotifications,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
} from "../redux/services/notificatrion/notification.Services";

function Header({ onToggleSidebar }) {
  const admin = useSelector((state) => state.auth);
  const [dropdown, setDropdown] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const notifRef = useRef(null);
  const dispatch = useDispatch();
  const profile = () => {
    setDropdown((prev) => !prev);
  };
  const navigate = useNavigate();
  const role = getUserRole();
  const adminData = getAdminData();
  const dropdownRef = useRef(null);
  const handleLogout = async () => {
    try {
      await logoutAdmin();
      localStorage.removeItem("adminToken");
      localStorage.clear();
      sessionStorage.clear();
      successToast("Logged out successfully");
      navigate("/login", { replace: true });
    } catch (error) {
      console.log(error);
      localStorage.removeItem("adminToken");
      localStorage.clear();
      sessionStorage.clear();

      errorToast("Logout failed but session cleared");

      navigate("/login", { replace: true });
    }
  };
  const fetchNotifications = async () => {
    try {
      const payload = {
        page: 1,
        per_page: 5,
      };

      const res = await getDropdownNotifications(payload);

      // API response structure ke according data extract karein
      const list =
        res?.data?.notifications ??
        res?.data?.data ??
        res?.data?.notifications?.data ??
        res?.data ??
        [];

      setNotifications(Array.isArray(list) ? list.slice(0, 5) : []);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
      setNotifications([]);
    }
  };
  // useEffect(() => {
  //   fetchNotifications();
  //   const interval = setInterval(fetchNotifications, 30000);
  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
    const initCount = async () => {
      try {
        const countRes = await getUnreadCount({});
        const count = countRes?.data?.count || countRes?.count || countRes?.data || 0;
        setUnreadCount(typeof count === "number" ? count : 0);
      } catch (err) {
        console.log(err);
      }
    };
    initCount();
  }, []);
  const handleMarkRead = async (id, e) => {
    e?.stopPropagation();
    try { await markNotificationRead(id); fetchNotifications(); } catch { }
  };

  const handleMarkAll = async (e) => {
    e?.stopPropagation();
    try { await markAllNotificationsRead(); fetchNotifications(); } catch { }
  };
  useEffect(() => {

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdown(false);
      }
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setShowNotif(false);
      }
    };


    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className='header' id='header'>
      <div className="d-flex justify-content-between align-items-center px-2 w-100">
        <div className="d-flex align-items-center gap-3">
          <div className="togglebutton">
            <TfiMenu onClick={onToggleSidebar} />
          </div>

        </div>
        <div className="linksmode d-flex align-items-center gap-2">
          {/* <div className="header-icon-btn">
            <FiBell />
          </div> */}
          {/* Purana ye tha: */}
          {/* <div className="header-icon-btn">
  <FiBell />
</div> */}


          <div className="header-icon-btn-wrap" ref={notifRef}>
            <div
              className="header-icon-btn"
              onClick={() => {
                const isOpening = !showNotif;

                setShowNotif(isOpening);

                if (isOpening) {
                  fetchNotifications();
                }
              }}
              role="button"
            >
              <FiBell />

              {unreadCount > 0 && (
                <span className="notification-badge">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </div>

            {showNotif && (
              <div className="notif-dropdown-panel">
                <div className="notif-dropdown-head">
                  <div>
                    <h6>Notifications</h6>
                    <span>{unreadCount} unread</span>
                  </div>
                  {unreadCount > 0 && (
                    <button onClick={handleMarkAll}><FiCheck /> All</button>
                  )}
                </div>

                <div className="notif-dropdown-list">
                  {notifications.length === 0 ? (
                    <div className="notif-dropdown-empty">
                      <FiInbox />
                      <p>No notifications</p>
                    </div>
                  ) : (
                    notifications.map((n) => {
                      const id = n._id || n.id;
                      return (
                        <div
                          key={id}
                          className={`notif-dropdown-item ${n.isRead ? "read" : "unread"
                            }`}
                          onClick={() => {
                            setShowNotif(false);
                            window.location.href = "/all-notification-list";
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="notif-dd-icon"><FiBell /></div>
                          <div className="notif-dd-content">
                            <h6>{n.title || "Notification"}</h6>
                            <p>{n.message || "No message"}</p>
                            <small>
                              {n.createdAt ? new Date(n.createdAt).toLocaleString() : "—"}
                            </small>
                          </div>
                          {!n.isRead && <span className="notif-dd-dot" />}
                        </div>
                      );
                    })
                  )}
                </div>

                <div className="notif-dropdown-footer">
                  <button
                    onClick={() => {
                      navigate("/all-notification-list");
                      setShowNotif(false);
                    }}
                  >
                    View All Notifications →
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* <div
            className="header-icon-btn"
            onClick={() => navigate("/notification-list")}
            title="Notifications"
            role="button"
          >
            <FiBell />
            {unreadCount > 0 && (
              <span className="notification-badge">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </div> */}
          <div className="profilie">
            <div className="d-flex align-items-center gap-2 ">
              <div className="profileimage">
                {/* <img src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`} alt="Avatar" /> */}
                <img src={a2only} alt="" />
              </div>
              <div className="dropdown" ref={dropdownRef}>
                <button
                  type="button"
                  className="dropdown-toggle d-flex align-items-center gap-2"
                  onClick={profile}
                >
                  <span className="d-none d-md-block">
                    {adminData?.name}
                  </span>
                </button>
                {dropdown && (
                  <div className="custom-dropdown">

                    <div className="dropdown-header">
                      <img
                        src={a2only}
                        alt="user"
                        className="user-avatar"
                      />
                      <div>
                        <h6>{adminData?.name}</h6>
                        <span>{adminData?.email}</span>
                      </div>
                    </div>
                    <div className="dropdown-divider"></div>
                    <button
                      className="dropdown-btn"
                      onClick={() => {
                        navigate("/profile");
                      }}
                    >
                      <FiUser />
                      <span>My Profile</span>
                    </button>
                    {role === "admin" && (
                      <button
                        className="dropdown-btn"
                        // onClick={() => navigate("/change-status")}
                        onClick={() => {
                          dispatch(
                            openModal({
                              type: "change-password",
                              title: "Change Password",
                              data: null,
                            })
                          );

                          setDropdown(false);
                        }}
                      >
                        <FiSettings />
                        <span>Change Password</span>
                      </button>
                    )}


                    <div className="dropdown-divider"></div>

                    <button
                      className="dropdown-btn logout-btn"
                      onClick={handleLogout}
                    >
                      <FiLogOut />
                      <span>Logout</span>
                    </button>

                  </div>
                )}
              </div>

              {/* <div className="arrowprofile">
                                <IoIosArrowDown />
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
